import {
    FETCH_LIST,
    LIST_FETCHED,
    SHOW_CASH_COUPON_DIALOG,
    DELETE_CASH_COUPON,
    TOGGLE_LOADING
  } from './actionTypes'
  
  export const fetchList = (params) => ({
    type: FETCH_LIST,
    payload: {
      params
    }
  })
  export const toggleLoading = () => ({
    type: TOGGLE_LOADING
  })
  export const listFetched = result => ({
    type: LIST_FETCHED,
    payload: result
  })

  export const showCashCouponDialog = params => ({
    type: SHOW_CASH_COUPON_DIALOG,
    payload: { params }
  })
  export const deleteCashCoupon = (id,onSuccess) => ({
    type: DELETE_CASH_COUPON,
    payload: { id,onSuccess }
  })
  